import * as React from 'react';
import { OrderByEnum } from '../../data-grid.type';
import { ArrowDown, ArrowUp } from '@components/atoms';

interface SortIndicatorProps {
  columnSort: OrderByEnum;
  isActive?: boolean; // Determine if this is the actively sorted column
}

export const SortIndicator: React.FC<SortIndicatorProps> = ({
  columnSort,
  isActive,
}: SortIndicatorProps) => {
  if (!isActive) {
    return <ArrowDown className="ml-1 h-4 w-4 opacity-50" />;
  }

  if (columnSort === OrderByEnum.ASC) {
    return <ArrowUp className="ml-1 h-4 w-4" />;
  }

  return <ArrowDown className="ml-1 h-4 w-4" />;
};
